import React, { PureComponent } from 'react';
import { GenericSimpleButton, GenericSimpleIconButton } from 'com-gyf-webcore-userinterfacecomponents';

class ButtonAdd extends PureComponent {

  render() {

    const { validarCuenta, cancelar, Cuenta } = this.props;
    
    return (
    <div className="row bottom-separator-xs">

        <div className="col-xs-2">
          <GenericSimpleButton
             buttonId="updateMotivoBloqueo"
             buttonType="button"
             text="Aceptar"
             onClick={() => validarCuenta(Cuenta)}
             buttonClass="btn btn-cta"
          />
        </div>

        <div className="col-xs-2">
          <button type="button" className="btn btn-secondary" onClick={() => cancelar()}>Cancelar</button>
        </div>
       
     </div>
     );

  }
}

export default ButtonAdd;